export default __webpack_public_path__ + "static/media/vastaanotto.7cd311f3.svg";